import request from '@/utils/request'

/**
 * 同步商品
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象
 */
export function syncPartnerGoods(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.syncPartnerGoods',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取可选择的商品列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getPartnerGoodsList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.listPartnerGoods',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}